'use strict';

var baseTable = require('./base-table.json'); // map for hexString -> codecName


var nameTable = new Map();

for (var encodingName in baseTable) {
  var code = baseTable[encodingName];
  nameTable.set(code, encodingName);
}

module.exports = Object.freeze(nameTable);